var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"d-flex flex-column align-center justify-center",attrs:{"app":"","dark":"","color":"primary","height":"120"}},[_c('v-spacer'),_c('span',[_c('a',{staticClass:"white--text",attrs:{"href":"https://sap.starkcloud.com","target":"_blank"}},[_vm._v("StarkCloud LLC ©2023")])]),_c('div',{staticClass:"d-flex"}),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }